import axios from "axios";
import { apiURL } from './api.js';

// Function to send account deletion request
export const sendDeleteAccountRequest = async (formData, language = 'fr') => {
    try {
        if (!formData.firstName || !formData.lastName || !formData.email) {
            throw new Error('First name, last name, and email are required');
        }

        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            language: language
        };
        
        const response = await axios.post(`${apiURL}/account/delete-request`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        
        if (response.status !== 200 && response.status !== 201) {
            throw new Error('Failed to send deletion request');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error sending deletion request:', error);
        throw error;
    }
};
